'use client'

import { useState } from 'react'

/**
 * "Capa leve" (facade) do YouTube: mostra só a miniatura + botão ▶ e SÓ carrega o player pesado do YouTube
 * QUANDO o leitor clica. Antes, o `<iframe>` do player (centenas de KB de JS) carregava junto com a página,
 * deixando o post lento. Agora a página abre instantânea (só uma imagem) e o vídeo só pesa se for assistido.
 * `youtube-nocookie` mantido. Miniatura de `i.ytimg.com` (coberta por img-src https: da CSP).
 */
export function YouTubeFacade({ videoId, title }: { videoId: string; title: string }) {
  const [playing, setPlaying] = useState(false)
  return (
    <div
      className="embed-block embed-block--youtube"
      style={{
        position: 'relative',
        width: '100%',
        aspectRatio: '16 / 9',
        overflow: 'hidden',
        borderRadius: 8,
        background: '#000',
      }}
    >
      {playing ? (
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 0, display: 'block' }}
        />
      ) : (
        <button
          type="button"
          onClick={() => setPlaying(true)}
          aria-label={`Reproduzir vídeo: ${title}`}
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            padding: 0,
            border: 0,
            cursor: 'pointer',
            display: 'block',
            background: 'transparent',
          }}
        >
          {/* eslint-disable-next-line @next/next/no-img-element -- miniatura externa do YouTube (facade); next/image
              exigiria domínio remoto + otimização desnecessária para uma imagem trocada por iframe ao clicar. */}
          <img
            src={`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`}
            alt=""
            loading="lazy"
            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
          />
          <span
            aria-hidden="true"
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 68,
              height: 48,
              borderRadius: 12,
              background: 'rgba(0, 0, 0, 0.72)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <span
              style={{
                width: 0,
                height: 0,
                marginLeft: 4,
                borderStyle: 'solid',
                borderWidth: '11px 0 11px 18px',
                borderColor: 'transparent transparent transparent #fff',
              }}
            />
          </span>
        </button>
      )}
    </div>
  )
}
